<template>
    <div v-if="logoPath" class="parallax" :class="{ show: isVisible }" ref="parallaxElement">
        <div class="logo">
            <img :src="logoPath" alt="Logo" />
        </div>
    </div>
</template>

<script setup lang="ts">
    import { onBeforeUnmount, onMounted, ref, watch } from "vue";

    const props = defineProps<{
        logoPath?: string;
        scrollableElement?: HTMLElement;
    }>();

    const parallaxElement = ref<HTMLElement>();
    const isVisible = ref(true);

    function handleScroll() {
        if (!props.scrollableElement) return;

        const $scrollable = $(props.scrollableElement);
        const offset = $scrollable.scrollTop();
        isVisible.value = offset <= 35;
    }

    function setupScrollListener() {
        if (!props.scrollableElement || !parallaxElement.value) return;

        const $scrollable = $(props.scrollableElement);
        $scrollable.unbind("scroll.parallax").bind("scroll.parallax", handleScroll);
    }

    function removeScrollListener() {
        if (!props.scrollableElement) return;
        $(props.scrollableElement).unbind("scroll.parallax");
    }

    function updateScrollListener() {
        removeScrollListener();
        if (props.logoPath && props.scrollableElement) {
            setupScrollListener();
        }
    }

    watch([() => props.logoPath, () => props.scrollableElement], () => {
        updateScrollListener();
    });

    onMounted(() => {
        updateScrollListener();
    });

    onBeforeUnmount(() => {
        removeScrollListener();
    });
</script>

<style lang="scss">
    @use "./../../../../assets/styles/scss/shared/_variables.scss";

    // kiosk: 50% larger, the logo follows the container height
    .kiosk-mode .parallax {
        height: 171px;

        > .logo {
            padding: 27px 36px 27px 36px;
        }
    }

    .parallax {
        height: 114px;
        background-color: #fff;
        background-color: var(--headerBackgroundColor);

        > .logo {
            padding: 18px 24px 18px 24px;
            text-align: center;
            height: 100%;
            box-sizing: border-box;
            opacity: 0;
            transition:
                opacity 1s variables.$easeOutExpo,
                transform 1s variables.$easeOutExpo;
            transform: scale(0.5);

            > img {
                height: 100%;
                width: 100%;
                object-fit: contain;
                object-position: center center;
            }
        }

        &.show {
            > .logo {
                transform: scale(1);
                opacity: 1;
            }
        }
    }
</style>
